import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ErrorOutlineIcon(props: FixMe) {
  return <ErrorOutline {...props} />;
}

export default ErrorOutlineIcon;
